import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  token: null,
  error: null,
  userId: null,
  loading: false,
  userName: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.AUTH_START: {
      return {
        ...state,
        error: null,
        loading: true
      };
    }

    case actionsTypes.AUTH_SUCCESS: {
      return {
        ...state,
        token: action.token,
        userId: action.userId,
        error: null,
        loading: false,
        userName: action.userName
      };
    }

    case actionsTypes.AUTH_FAIL: {
      return {
        ...state,
        error: action.error,
        loading: false
      };
    }

    case actionsTypes.AUTH_LOGOUT: {
      return {
        ...state,
        token: null,
        userId: null,
        userName: ''
      };
    }

    default:
      return state;
  }
};

export default reducer;
